import posthog from 'posthog-js';

import { isPostHogEnabled } from './isPostHogEnabled';

export const trackClusterConnected = ({
  organization_id,
  cluster_id,
}: {
  organization_id: string;
  cluster_id: string;
}) => {
  if (!isPostHogEnabled) {
    return;
  }
  posthog.capture('Activation: Cluster connected', {
    organization_id,
    cluster_id,
  });
};

export const trackAllocationGroupCreated = ({
  organization_id,
  allocation_group_id,
  cluster_id,
}: {
  organization_id: string;
  allocation_group_id: string;
  cluster_id?: string;
}) => {
  if (!isPostHogEnabled) {
    return;
  }
  posthog.capture('Activation: Allocation group created', {
    organization_id,
    allocation_group_id,
    cluster_id,
  });
};

export const trackBudgetCreated = ({
  organization_id,
  budget_id,
}: {
  organization_id: string;
  budget_id: string;
}) => {
  if (!isPostHogEnabled) {
    return;
  }
  posthog.capture('Activation: Budget created', {
    organization_id,
    budget_id,
  });
};
